module.exports = __webpack_public_path__ + "img/icon-letter-k.d1f616a0.svg";